import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsOverview = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      <div className="card hover:shadow-lg transition-all duration-250">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Users" size={24} color="var(--color-primary)" />
          </div>
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
            +{stats?.clientsChange}%
          </span>
        </div>
        <h3 className="text-sm text-muted-foreground mb-1">Active Clients</h3>
        <p className="text-3xl font-bold text-foreground">{stats?.activeClients}</p>
        <p className="text-xs text-muted-foreground mt-2">
          {stats?.newClientsThisMonth} new this month
        </p>
      </div>
      <div className="card hover:shadow-lg transition-all duration-250">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="Calendar" size={24} color="var(--color-accent)" />
          </div>
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
            Today
          </span>
        </div>
        <h3 className="text-sm text-muted-foreground mb-1">Sessions Today</h3>
        <p className="text-3xl font-bold text-foreground">{stats?.sessionsToday}</p>
        <p className="text-xs text-muted-foreground mt-2">
          {stats?.completedSessions} completed, {stats?.upcomingSessions} upcoming
        </p>
      </div>
      <div className="card hover:shadow-lg transition-all duration-250">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-lg bg-success/10 flex items-center justify-center">
            <Icon name="DollarSign" size={24} color="var(--color-success)" />
          </div>
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-success/10 text-success">
            +{stats?.earningsChange}%
          </span>
        </div>
        <h3 className="text-sm text-muted-foreground mb-1">Monthly Earnings</h3>
        <p className="text-3xl font-bold text-foreground">${stats?.monthlyEarnings?.toLocaleString()}</p>
        <p className="text-xs text-muted-foreground mt-2">
          ${stats?.weeklyEarnings?.toLocaleString()} this week
        </p>
      </div>
      <div className="card hover:shadow-lg transition-all duration-250">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 rounded-lg bg-warning/10 flex items-center justify-center">
            <Icon name="Star" size={24} color="var(--color-warning)" />
          </div>
          <span className="px-3 py-1 rounded-full text-xs font-medium bg-warning/10 text-warning">
            {stats?.rating}/5.0
          </span>
        </div>
        <h3 className="text-sm text-muted-foreground mb-1">Client Rating</h3>
        <p className="text-3xl font-bold text-foreground">{stats?.rating}</p>
        <p className="text-xs text-muted-foreground mt-2">
          Based on {stats?.totalReviews} reviews
        </p>
      </div>
    </div>
  );
};

export default QuickStatsOverview;